var map = {
	"./dance.mp4": 238,
	"./dance_reduced.mp4": 389,
	"./ff1.mp4": 878,
	"./ff2.mp4": 193,
	"./ff3.mp4": 348,
	"./good_out_arrows_heads.mp4": 24,
	"./squat_posture_v.mp4": 727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 933;